import React from 'react';
import PropTypes from 'prop-types';
import {
  DescriptionList,
  DescriptionListLabel,
  DescriptionListValue,
  HorizontalRule,
} from '../../atoms';
import { costFormatter } from '../../format';
import { SummaryCard } from '../SummaryCard';
import {
  BoldText,
  Headline,
  LightText,
  Price,
  PriceWithDiscount,
  Pricing,
  StyledStarterBoxCheckoutSummary,
  SummaryCardContent,
} from './styles.js';
import { CheckoutSummaryDisplayRecipes } from './components';

export const StarterBoxCheckoutSummary = ({
  avatarBgColor,
  breeds,
  headline,
  nextDeliveryDate,
  numPacksCopy,
  bagCount,
  productType,
  recipes,
  petId,
  pricePerWeek,
  pricePerWeekWithDiscount,
  onDeletePet,
}) => {
  return (
    <StyledStarterBoxCheckoutSummary>
      <SummaryCard
        avatarBgColor={avatarBgColor}
        breeds={breeds}
        onDeletePet={onDeletePet}
        petId={petId}
      >
        <SummaryCardContent>
          <Headline>{headline}</Headline>
          <Pricing>
            <Price>{costFormatter(pricePerWeek) + '/Week'}</Price>
            {pricePerWeekWithDiscount !== '0.00' ? (
              <PriceWithDiscount>
                {costFormatter(pricePerWeekWithDiscount) + '/Week'}
              </PriceWithDiscount>
            ) : (
              <PriceWithDiscount>
                {costFormatter(pricePerWeekWithDiscount)}
              </PriceWithDiscount>
            )}
          </Pricing>
        </SummaryCardContent>
      </SummaryCard>
      <HorizontalRule />
      <DescriptionList>
        <DescriptionListLabel>{'Preparation'}</DescriptionListLabel>
        <DescriptionListValue>
          {productType === 'FR' && <BoldText>{'All Fresh'}</BoldText>}
          {productType === 'DY' && <BoldText>{'All Baked'}</BoldText>}
          {productType === 'MX' && <BoldText>{'Mixed Bowl'}</BoldText>}
        </DescriptionListValue>
        <CheckoutSummaryDisplayRecipes
          productType={productType}
          recipes={recipes}
          numPacksCopy={numPacksCopy}
          bagCount={bagCount}
        />
        <DescriptionListLabel>Estimated Delivery</DescriptionListLabel>
        <DescriptionListValue>
          {nextDeliveryDate ? (
            <BoldText>{nextDeliveryDate}</BoldText>
          ) : (
            <LightText>Enter Address</LightText>
          )}
        </DescriptionListValue>
      </DescriptionList>
    </StyledStarterBoxCheckoutSummary>
  );
};
StarterBoxCheckoutSummary.displayName = 'StarterBoxCheckoutSummary';
StarterBoxCheckoutSummary.propTypes = {
  avatarBgColor: PropTypes.string.isRequired,
  breeds: PropTypes.arrayOf(PropTypes.string).isRequired,
  headline: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
  recipes: PropTypes.object.isRequired,
  pricePerWeek: PropTypes.string.isRequired,
  pricePerWeekWithDiscount: PropTypes.string.isRequired,
  onDeletePet: PropTypes.func,
  nextDeliveryDate: PropTypes.string,
  numPacksCopy: PropTypes.string.isRequired,
  bagCount: PropTypes.number.isRequired,
  petId: PropTypes.string,
};
